import api from '../..'

const requests = {
    fetch: async (requestStatuses, serviceTaskStatuses, dates) => {
        let requestCompletedFromDate = null
        let requestCompletedToDate = null

        let serviceTaskFromDate = null
        let serviceTaskToDate = null

        if (dates.find((v) => v.filter == 'requestCompleted')) {
            let d = dates.find((v) => v.filter == 'requestCompleted')
            requestCompletedFromDate = d.fromDate ? new Date(d.fromDate).toISODateString() : null
            requestCompletedToDate = d.toDate ? new Date(d.toDate).toISODateString() : null
        }

        if (dates.find((v) => v.filter == 'serviceTaskDate')) {
            let d = dates.find((v) => v.filter == 'serviceTaskDate')
            serviceTaskFromDate = d.fromDate ? new Date(d.fromDate).toISODateString() : null
            serviceTaskToDate = d.toDate ? new Date(d.toDate).toISODateString() : null
        }

        var response = await api.post(`/maarima/export`, {
            requestStatuses: requestStatuses.map((v) => v.id) || [],
            serviceTaskStatuses: serviceTaskStatuses.map((v) => v.id) || [],

            requestCompletedFromDate: requestCompletedFromDate,
            requestCompletedToDate: requestCompletedToDate,

            serviceTaskFromDate: serviceTaskFromDate,
            serviceTaskToDate: serviceTaskToDate
        })
        return response.data
    }
}

export default requests
